module.exports = __webpack_public_path__ + "static/media/promo-pregnancy.5b51cef0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-pregnancy.jpg
// module id = 315
// module chunks = 0